export default {
  BusinessPurchaseComponentsExcel: {
    title: 'Import',
    rules: 'Excel Import Supplier Rules Description',
    p1: 'If the system already has supplier code information, update the data according to the supplier code; otherwise, create new supplier information.',
    p2: 'Import supplier information template, click to download',
    information: 'Supplier Information Template',
    p3: 'The Excel file must contain headers, and red headers are required; please set the columns in Excel as text format, otherwise there may be type conversion errors',
    p4: 'Supported Formats: csv, xls, xlsx. The file size for a single import cannot exceed 128MB, and the number of data rows cannot exceed 60,000. If it exceeds, please import in multiple batches.',
    uploadSize: 'The upload size cannot exceed 128MB.',
    import: 'Confirm Import',
    name: 'Supplier Information Template.xlsx'
  }
};
